// The toast the server renders from `flash`, built in the browser for what
// never reaches the server: same markup and same controller, so it slides in,
// closes and times out the way every other flash on the site does.
const TONES = {
  alert: 'bg-danger',
  error: 'bg-danger',
  notice: 'bg-deep_blue',
  success: 'bg-deep_blue'
};

const FLASH_CLASSES = [
  'fixed', 'bottom-0', 'tablet:left-1/2', 'tablet:-ml-[214px]', 'w-full', 'tablet:w-[428px]',
  'p-4', 'tablet:p-6', 'text-white', 'rounded-t-2xl', 'tablet:rounded-t-[32px]', 'shadow-lg',
  'pointer-events-auto', 'z-[9999]'
];

const CLOSE_BUTTON_CLASSES = [
  'absolute', 'right-0', 'inline-flex', 'p-4', 'text-white', 'top-0', 'md:top-2', 'focus:outline-none'
];

const CLOSE_ICON = '<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>';

function showFlash(message, { type = 'notice', autoClose = 6000 } = {}) {
  // The frame is part of the layout, so a page rendered without one simply has
  // nowhere to say this.
  const container = document.getElementById('flash');

  if (!container) {
    return null;
  }

  const flash = document.createElement('div');
  flash.setAttribute('data-controller', 'flash');
  flash.setAttribute('data-flash-auto-close', String(autoClose));
  flash.classList.add(TONES[type] ?? TONES.notice, ...FLASH_CLASSES);
  // The controller slides it up from here once it connects.
  flash.style.transform = 'translate(0, 600px)';

  const text = document.createElement('p');
  text.classList.add('text-sm', 'md:text-base', 'pr-4');
  text.innerText = message;

  const closeButton = document.createElement('button');
  closeButton.setAttribute('type', 'button');
  closeButton.setAttribute('data-action', 'flash#close');
  closeButton.classList.add(...CLOSE_BUTTON_CLASSES);
  closeButton.innerHTML = CLOSE_ICON;

  flash.append(text, closeButton);
  container.appendChild(flash);

  return flash;
}

export default showFlash;
